import React, { forwardRef, useImperativeHandle, useCallback } from 'react';
import GuestTable from '../../CheckIn/GuestTable/GuestTable';
import useGuestFormHook from './GuestForms.hook.js';

const GuestForms = forwardRef(function GuestForms(
  { selectedLanguage, selectedHotelId, languages, isLoading, onSave },
  ref
) {
  const { state, actions } = useGuestFormHook({
    selectedLanguage,
    selectedHotelId,
  });

  const saveClicked = useCallback(
    applyToAllHotels => {
      onSave(state.guestForm, applyToAllHotels);
    },
    [onSave, state.guestForm]
  );

  useImperativeHandle(ref, () => ({ saveClicked }), [saveClicked]);

  return (
    <div>
      <GuestTable
        isLoading={state.isLoading || isLoading}
        data={state.guestForm || []}
        onFieldStateChecked={actions.onFieldStateChecked}
        onFieldRequiredChecked={actions.onFieldRequiredChecked}
        onFieldTextChanged={actions.onFieldTextChanged}
        selectedLanguage={selectedLanguage}
        hotelId={selectedHotelId}
        supportedLanguages={languages}
      />
    </div>
  );
});

export default GuestForms;
